export const STATUS_WIDGET_ERROR_MESSAGE = 'Error loading category stats';

export const STATUS_WIDGET_PAYOUT_ARIA_LABEL = 'Payouts statistics';
export const STATUS_WIDGET_PAYOUT_TITLE = 'Payouts';
export const STATUS_WIDGET_PAYOUT_TEST_ID_PREFIX =
  'dashboard-payout-widget-status-';

export const STATUS_WIDGET_ORDER_ARIA_LABEL = 'Orders statistics';
export const STATUS_WIDGET_ORDER_TITLE = 'Pay-ins';
export const STATUS_WIDGET_ORDER_TEST_ID_PREFIX =
  'dashboard-order-widget-status-';

export const ORDER_DOT_COLOR: Record<string, string> = {
  received: 'bg-surface-strong',
  processing: 'bg-feedback-info-strong',
  processing_refund: 'bg-status-processing',
  cancelled: 'bg-feedback-error-strong',
  authorised: 'bg-feedback-info',
  pending: 'bg-highlight-strong',
  action_required: 'bg-feedback-warning-strong',
  completed: 'bg-status-completed-active',
  refunded: 'bg-feedback-error-strong',
  partially_refunded: 'bg-feedback-warning-strong',
  action_required_for_refund: 'bg-feedback-warning-strong',
  refund_returned: 'bg-feedback-attention-strong'
};

export const PAYOUT_DOT_COLOR: Record<string, string> = {
  received: 'bg-surface-strong',
  processing: 'bg-feedback-info-strong',
  pending: 'bg-highlight-strong',
  rejected: 'bg-feedback-error-strong',
  completed: 'bg-status-completed-active',
  returned: 'bg-feedback-attention-strong',
  action_required: 'bg-feedback-warning-strong'
};
